import type { ParentComponent } from "solid-js";
import { Title } from "@solidjs/meta";
import { TrackingPixels, type TrackingPixelConfig } from "~/common/tag_scripts";

type Props = {
  pixelConfig: TrackingPixelConfig;
};

const PublicPageLayout: ParentComponent = (props) => <>{props.children}</>;

function TagVerificationShow(props: Props) {
  return (
    <>
      <Title>Marketing tag test</Title>
      <TrackingPixels trackingPixels={[props.pixelConfig]} />

      <div class="mx-auto w-full max-w-4xl sm:p-8 md:p-16">
        <main class="prose bg-white p-8 sm:rounded-xl">
          <p>
            This page is for testing the marketing tag only. If you see this message, the page
            loaded successfully.
          </p>
          <p>
            Use your provider's tools (e.g. Meta Pixel Helper, Google Tag Assistant) to verify that
            the tag fired.
          </p>
        </main>
      </div>
    </>
  );
}

TagVerificationShow.layout = PublicPageLayout;
export default TagVerificationShow;
